(function () {
  "use strict";

  /* ---- Scroll reveal ---- */
  var revealEls = document.querySelectorAll(".dmim-reveal");
  if (revealEls.length && "IntersectionObserver" in window) {
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    revealEls.forEach(function (el) { revealObserver.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("is-visible"); });
  }

  /* ---- Animated counters ---- */
  var counters = document.querySelectorAll("[data-dmim-count]");
  var DMIM_NUMBER_LOCALE_MAP = { tr: "tr-TR", en: "en-US", ar: "ar-EG" };
  var dmimNumberLocale = DMIM_NUMBER_LOCALE_MAP[(document.documentElement.lang || "tr").split("-")[0]] || "tr-TR";
  function animateCount(el) {
    var target = parseFloat(el.getAttribute("data-dmim-count"));
    var decimals = parseInt(el.getAttribute("data-dmim-decimals") || "0", 10);
    var duration = 1600;
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = target * eased;
      el.textContent = value.toLocaleString(dmimNumberLocale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      });
      if (progress < 1) window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
  }
  if (counters.length && "IntersectionObserver" in window) {
    var countObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCount(entry.target);
            countObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );
    counters.forEach(function (el) { countObserver.observe(el); });
  }

  /* ---- ERP showcase tabs ---- */
  document.querySelectorAll("[data-dmim-showcase]").forEach(function (root) {
    var tabs = root.querySelectorAll("[data-dmim-tab]");
    var panels = root.querySelectorAll("[data-dmim-panel]");
    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var target = tab.getAttribute("data-dmim-tab");
        tabs.forEach(function (t) { t.classList.remove("is-active"); });
        panels.forEach(function (p) { p.classList.remove("is-active"); });
        tab.classList.add("is-active");
        var panel = root.querySelector('[data-dmim-panel="' + target + '"]');
        if (panel) panel.classList.add("is-active");
      });
    });
  });

  /* ---- Pricing monthly/yearly toggle ---- */
  document.querySelectorAll("[data-dmim-pricing]").forEach(function (root) {
    var toggle = root.querySelector("[data-dmim-switch]");
    var monthlyLabel = root.querySelector('[data-dmim-period-label="monthly"]');
    var yearlyLabel = root.querySelector('[data-dmim-period-label="yearly"]');
    var priceEls = root.querySelectorAll("[data-monthly]");
    var isYearly = false;

    function render() {
      priceEls.forEach(function (el) {
        var val = isYearly ? el.getAttribute("data-yearly") : el.getAttribute("data-monthly");
        el.textContent = val;
      });
      if (toggle) toggle.classList.toggle("is-yearly", isYearly);
      if (monthlyLabel) monthlyLabel.classList.toggle("is-active", !isYearly);
      if (yearlyLabel) yearlyLabel.classList.toggle("is-active", isYearly);
    }

    if (toggle) {
      toggle.addEventListener("click", function () {
        isYearly = !isYearly;
        render();
      });
    }
    render();
  });

  /* ---- FAQ accordion ---- */
  document.querySelectorAll(".dmim-faq__item").forEach(function (item) {
    var q = item.querySelector(".dmim-faq__q");
    var a = item.querySelector(".dmim-faq__a");
    if (!q || !a) return;
    q.addEventListener("click", function () {
      var isOpen = item.classList.contains("is-open");
      item.closest(".dmim-faq").querySelectorAll(".dmim-faq__item").forEach(function (el) {
        el.classList.remove("is-open");
        el.querySelector(".dmim-faq__a").style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add("is-open");
        a.style.maxHeight = a.scrollHeight + "px";
      }
    });
  });
})();
